import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "bar"]

  connect() {
    this.update()
    this.containerTarget.addEventListener("scroll", this.update, { passive: true })
  }

  disconnect() {
    this.containerTarget.removeEventListener("scroll", this.update)
  }

  update = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget
    const maxScroll = scrollWidth - clientWidth
    if (maxScroll <= 0) {
      this.barTarget.style.width = "100%"
      return
    }
    const progress = Math.min(scrollLeft / maxScroll, 1)
    this.barTarget.style.width = `${Math.max(progress * 100, 10)}%`
  }
}
